import { REGROUPEMENT } from '@/configuration/devisConf';
import moment from 'moment';
import { REGIE } from '@/configuration/societe/societe';

function datePreavisWithDateRenouvellement(dcf) {
  if (!dcf.dateRenouvellement) return null;
  return moment(dcf.dateRenouvellement)
    .subtract(3, 'month').toDate();
}

function datePreavisWithNombreMoisPreavisAndParam(
  dateRenouvellement, nombreMoisPreavis, delaiAdministratif,
) {
  let date = null;
  const isInt = Number.isInteger(nombreMoisPreavis);
  if (isInt) date = moment(dateRenouvellement).add(-1 * nombreMoisPreavis, 'months');
  else date = moment(dateRenouvellement).add(Math.round(-30 * nombreMoisPreavis), 'days');
  date.add(-1 * delaiAdministratif, 'd');
  return date.toDate();
}

export default function calculDatePreavis(dcf, delaiAdministratif) {
  const lignes = dcf.lignesCommande.filter((ligne) => {
    return ligne.type === REGROUPEMENT;
  });
  if (!dcf.renouvelable || lignes.length !== 1) return datePreavisWithDateRenouvellement(dcf);
  const annonceurs = dcf.intervenants.filter((int) => {
    return int.annonceur;
  });
  if (dcf.role === REGIE && annonceurs.length === 1
    && annonceurs[0].tiers.nombreMoisPreavis) {
    return datePreavisWithNombreMoisPreavisAndParam(
      dcf.dateRenouvellement,
      annonceurs[0].tiers.nombreMoisPreavis,
      delaiAdministratif,
    );
  } if (dcf.role === REGIE) return datePreavisWithDateRenouvellement(dcf);
  if (dcf.role !== REGIE
  && lignes[0].produit.tiers
  && lignes[0].produit.tiers.nombreMoisPreavis) {
    return datePreavisWithNombreMoisPreavisAndParam(
      dcf.dateRenouvellement,
      lignes[0].produit.tiers.nombreMoisPreavis,
      delaiAdministratif,
    );
  }
  return datePreavisWithDateRenouvellement(dcf);
}
